import accountingCustomers from './accounting/customers'
import accountingInvoices from './accounting/invoices'
import accountingJournals from './accounting/journals'
import accountingProducts from './accounting/products'
import accountingVatCodes from './accounting/vatCodes'
import additions from './additions'
import attributes from './attributes'
import auth from './auth'
import berthFees from './berthFees'
import billOfLadings from './billOfLadings'
import brokers from './brokers'
import cargoCategories from './cargoCategories'
import cargoHoldFloors from './cargoHoldFloors'
import cargoOverview from './cargoOverview'
import cargoProjects from './cargoProjects'
import cargoTypes from './cargoTypes'
import cargos from './cargos'
import certificationClaimTypes from './certificationClaimTypes'
import clients from './clients'
import companies from './companies'
import conversations from './conversations'
import countries from './countries'
import dashboard from './dashboard'
import documents from './documents'
import favouriteGroups from './favouriteGroups'
import filter from './filter'
import flatTransports from './flatTransports'
import map from './map'
import messages from './messages'
import notifications from './notifications'
import offers from './offers'
import phoneCountryCodes from './phoneCountryCodes'
import terminals from './terminals'
import transferTimes from './transferTimes'
import transportDetails from './transportDetails'
import transports from './transports'
import users from './users'
import vesselDetails from './vesselDetails'
import vessels from './vessels'
import viewport from './viewport'
import v3 from './v3'
export default {
	auth,
	map,
	viewport,
	messages,
	notifications,
	vessels,
	users,
	dashboard,
	countries,
	phoneCountryCodes,
	transferTimes,
	cargoTypes,
	cargoHoldFloors,
	berthFees,
	additions,
	certificationClaimTypes,
	transportDetails,
	vesselDetails,
	attributes,
	terminals,
	companies,
	cargos,
	offers,
	conversations,
	cargoOverview,
	accountingProducts,
	accountingVatCodes,
	accountingJournals,
	accountingInvoices,
	accountingCustomers,
	transports,
	flatTransports,
	cargoProjects,
	clients,
	brokers,
	filter,
	billOfLadings,
	documents,
	cargoCategories,
	v3,
    favouriteGroups
}
